import {
  SET_ISTABLET,
  CLEAR_ISTABLET,
  SET_NO_SKIP_COUNT,
  CLEAR_NO_SKIP_COUNT
} from "../actions/type";

// Load initial state from localStorage
const loadIsTablet = () => {
  try {
    const savedIsTablet = localStorage.getItem("isTablet");
    return savedIsTablet === "true";
  } catch (e) {
    return false;
  }
};

const INIT_STATE = {
  isTablet: loadIsTablet(),
  noSkipCount: false
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case SET_ISTABLET:
      // Persist to localStorage
      try {
        localStorage.setItem("isTablet", String(payload));
      } catch (e) {
        console.error("Failed to save isTablet to localStorage:", e);
      }
      return { ...state, isTablet: payload };
    case CLEAR_ISTABLET:
      // Clear from localStorage
      try {
        localStorage.removeItem("isTablet");
      } catch (e) {
        console.error("Failed to clear isTablet from localStorage:", e);
      }
      return { ...INIT_STATE };
    case SET_NO_SKIP_COUNT:
      return { ...state, noSkipCount: payload };
    case CLEAR_NO_SKIP_COUNT:
      return { ...state, noSkipCount: false };

    default:
      return state;
  }
};
